import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { GetUsersList } from "../Responses/GetUsersList";

export async function getUsersList(data) {
	let response = await getAPIResponse("/v1/user-list", data);
	if (response === null) {
		return null;
	}
	let getUsersList = GetUsersList.createFromResponseData(response);
	return getUsersList;
}